import React from "react";
import CodeIcon from "@mui/icons-material/Code";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import Interaction from "../../../models/interactions/Interaction";
import useConditions from "../../../hooks/useConditions";
import InteractionNode from "../../../models/interactions/InteractionNode";
import { useStoreSelector } from "../../../store/Hooks";

interface InteractionConditionsButtonProps {
  interaction: Interaction;
  condition_id: number | null;
  interaction_node: InteractionNode;
  disabled?:boolean
}

const InteractionConditionsButton = (
  props: InteractionConditionsButtonProps,
) => {
  const rightDrawerOpen = useStoreSelector(
    (state) => state.nav.rightDrawerOpen,
  );
  //   const interactions = useStoreSelector((state) => state.interactionTree.Interactions);

  //   let thisInteractionIndex = interactions.findIndex(
  //     (interaction) => props.child == interaction.id
  //   );
  //   let thisInteraction = interactions[thisInteractionIndex];

  const { openConditionsBuilder } = useConditions();

  let tooltipTitle = "Add Conditions";
  let color = "";
  if (props.condition_id) {
    color = "#ffd91a";
    tooltipTitle = "Condition applied. Click to edit.";
  }

  function handleOpenConditions() {
    if (props.interaction_node !== null) {
      openConditionsBuilder(
        InteractionNode,
        props.interaction_node.id,
        props.interaction_node.condition_id,
        true,
        "Interaction " + props.interaction.title,
      );
    }
  }

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton disabled={props.disabled || rightDrawerOpen} onClick={handleOpenConditions}>
        <CodeIcon style={{ color: color }} />
      </IconButton>
    </Tooltip>
  );
};

export default InteractionConditionsButton;
